import { USER_ROLE_KEY } from "@/helpers/localStorageLabels";
import BaseAPIClient from "@/services/baseClient";

class BatchClient extends BaseAPIClient {
	createInstance() {
		super.createInstance();

		this.instance.defaults.baseURL =
			process.env.NODE_ENV === "production"
				? "/api/v1/"
				: process.env.VUE_APP_CACHE_API_URI;

		// Note: Base class already handles 401 with token refresh
		// This interceptor is kept for ANALYST-specific logging (TEMP code)
		this.instance.interceptors.response.use(
			(response) => {
				return response;
			},
			async (error) => {
				if (error.response?.status === 401 && !error.config._retry) {
					const userRole = localStorage.getItem(USER_ROLE_KEY);
					if (userRole === "ANALYST") {
						//TEMP - logging for debugging
						const localStorageData = {};
						for (let i = 0; i < localStorage.length; i++) {
							const key = localStorage.key(i);
							const value = localStorage.getItem(key);
							localStorageData[key] = value;
						}
						try {
							const apiClient = (await import("./apiClient")).default;
							await apiClient.cleanLocalStorage?.(
								"cacheServiceClient.js",
								JSON.stringify(localStorageData),
							);
						} catch (e) {
							console.error("Failed to log localStorage:", e);
						}
						//TEMP
						console.log(
							"401 received in cacheServiceClient - token refresh handled by baseClient",
						);
					}
				}
				return Promise.reject(error);
			},
		);
	}

	async resetWhiteList() {
		return this.instance.put("/admin/settings/whitelist_reload");
	}

	async resetUsers() {
		return this.instance.put("/admin/settings/users_reload");
	}

	// resetTenants
	async resetTenants() {
		return this.instance.put("/admin/settings/tenants_reload");
	}

	async getUsers(role, tenantId) {
		return this.instance.get(`/users?userRole=${role}&tenantId=${tenantId}`);
	}

	async getTeamsFromCache(tenantId, positionNames) {
		let urlForRequest = "/get-teams?";
		if (tenantId !== undefined) {
			urlForRequest += `tenantId=${tenantId}&`;
		}
		if (positionNames) {
			urlForRequest += `positionNames=${positionNames}&`;
		}
		return this.instance.get(urlForRequest);
	}

	async getAchProgress(tenantId, fileId) {
		if (fileId) {
			return this.instance.get(
				`/getAchProgress?fileId=${fileId}&tenantId=${tenantId}`,
			);
		} else {
			return this.instance.get(`/getAchProgress?tenantId=${tenantId}`);
		}
	}
}

export default new BatchClient();
